import React from 'react';
import BarChart from '../../ui/BarChart';

const TrackIssueCompletionChart = ({
  data = [],
  labels = null,
  onExpand,
  title = 'Track and Issue Completion',
  yAxisLabel = 'Tasks and Issues',
}) => {
  // Data should already be in { tasks: number, issues: number } format from parent
  const chartData = data;

  // Always show the chart structure, even with empty data
  return (
    <BarChart
      data={chartData}
      labels={labels}
      title={title}
      xAxisLabel="Sites"
      yAxisLabel={yAxisLabel}
      barColor="#22c55e"
      onExpand={onExpand}
      className="h-80"
    />
  );
};

export default TrackIssueCompletionChart;
